import React from 'react';
import styles from './BaseP.module.css';

const BaseP = props => {
	return <p className={`${styles.BaseP} ${props.passOnClasses}`}>{props.children}</p>
}

export default BaseP;